import * as React from 'react'
import styles from './style.module.css';
import Button from '../../../design-system/lib/Button';
import { ADDRESS_BOOK, AUTO_DISPATCH, CLOSE, CLOSE_DARK, CUSTOMER_TYPE, HISTORY, IC_SEARCH, INFO_CIRCLE, LOCATION, MAP, PERSON, PICKUP } from '../../../assets';
import DropDown from '../../../design-system/lib/DropDown';
import Modal from '../../../design-system/lib/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Service_Option, NewTravelResetReserve, New_Order_Reset_DropOff, New_Order_Reset_DropOffs, New_Order_Reset_Pickup, New_Travel_PaymentMethod, Remove_Service_Option, SetCanSaveTravel, SetPriceNewOrder, Set_Auto_ActiveVehicleType, Set_Auto_ActiveVehicleTypeـPickupDeliveryType_Pickup, Set_NewOrder_OrderType, Set_Pickup_Inputs, Set_Pickup_address, Set_SearchAutoCompleteLoading, Set_Service_ActiveVehicleType, Set_latlng, SetopenAddressBookInNewOrder } from '../../../Redux/actions/actionNames';
import { getCenterMap, setCenterMap } from '../../../helper/module';
import { GetVehicletypeByServiceAction, PlaceIdDetailsAction, SearchAutoCompleteAction, SearchAutoCompleteAction_local_address } from '../../../Redux/actions/actions';
import { useTranslation } from 'react-i18next';
import Input from '../../../design-system/lib/Input';
import IconProvider from '../../../design-system/lib/IconProvider';
import Typography from '../../../design-system/lib/Typography';
import CustomerListItem from '../customer/components/list-Item';
import SearchList from '../../../design-system/lib/SearchList';
import { v4 as uuidv4 } from 'uuid';
import _, { isEmpty } from "lodash";
import RecentAddressItem from './components/recentAddressItem';
import AddressItem from './components/addressItem';
import PickupInfoNewOrder from './components/info';
import Schedule from '../Schedule/Schedule';
import service_point from '../../../assets/service_point.svg';
import service_point_color from '../../../assets/service_point_color.svg';
import danger from '../../../assets/danger.svg';
import location_gray from '../../../assets/location_gray.svg';

import ServicePoint_addressItem from './components/servicePoint_addressItem';
import { ServicesApi } from '../../../service/API/service';


function PickupNewOrder({handleCollapse}) {
  const [isLocalAddressActive, setIsLocalAddressActive] = React.useState(global.config.dispatcherSettings.isLocalAddressActive);
  const [localSearchIsActive, setLocalSearchIsActive] = React.useState(global.config.dispatcherSettings.isLocalAddressActive ? true : false);
  const [id, setid] = React.useState("pickup");
  const [ordered, setOrdered] = React.useState(true);
  const [showpoper, setShowpoper] = React.useState(false);
  const [showpoperSaved, setShowpoperSaved] = React.useState(false);
  const [getFavAddressLoading, setGetFavAddressLoading] = React.useState(false);
  const [searchAddrees, setSearchAddrees] = React.useState("");
  const [sessionToken, setSessionToken] = React.useState(null);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const auto = useSelector((state) => state.NewOrder.newOrder.pickup.driver.auto)
  const favAddresss = useSelector((state) => state.FavAddress.list)
  const customerId = useSelector((state) => state.NewOrder.newOrder.customer.id)
  const BusinessId = useSelector((state) => state.NewOrder.newOrder.customer.BusinessId)
  const showDriver = useSelector((state) => state.NewOrder.newOrder.pickup.driver.chooseDriver)
  const mapRef = useSelector((state) => state.Map.mapRef)
  const center = useSelector((state) => state.Map.center)
  const address = useSelector((state) => state.NewOrder.newOrder.pickup.address)
  const adresss_loc = useSelector((state) => state.NewOrder.newOrder.pickup.adresss_loc)
  const name = useSelector((state) => state.NewOrder.newOrder.pickup.name)
  const idx = useSelector((state) => state.NewOrder.newOrder.pickup.idx)
  const unit = useSelector((state) => state.NewOrder.newOrder.pickup.unit)
  const emailg = useSelector((state) => state.NewOrder.newOrder.pickup.email)
  const senderFullName = useSelector((state) => state.NewOrder.newOrder.pickup.senderFullName)
  const senderPhoneNumber = useSelector((state) => state.NewOrder.newOrder.pickup.senderPhoneNumber)
  const noteForDriver = useSelector((state) => state.NewOrder.newOrder.pickup.noteForDriver)
  const scheduleDateBefore = useSelector((state) => state.NewOrder.newOrder.pickup.scheduleDateBefore)
  const scheduleDateAfter = useSelector((state) => state.NewOrder.newOrder.pickup.scheduleDateAfter)
  const list = useSelector((state) => state.NewOrder.newOrder.pickup.list)
  const loading = useSelector((state) => state.NewOrder.newOrder.pickup.loading)
  const activePickupDropOff = useSelector((state) => state.NewOrder.newOrder.activePickupDropOff)
  const suggestListPickUpDropOffLoading = useSelector((state) => state.NewOrder.newOrder.suggestListPickUpDropOffLoading)
  const suggestListPickUpDropOffOrdered = useSelector((state) => state.NewOrder.newOrder.suggestListPickUpDropOffOrdered)
  const suggestPickUpDropOffListData = useSelector((state) => state.NewOrder.newOrder.suggestPickUpDropOffListData)
  const lang = useSelector((state) => state.LocalData.lang)
  const activeVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const openAddressBook = useSelector((state) => state.Addressbook.openAddressBookInNewOrder)
  const orderTypeActive = useSelector((state) => state.NewOrder.newOrder.orderTypeActive)
  const recentAddress = useSelector((state) => state.NewOrder.newOrder.customer.recentAddreess)
  const ActivescheduleSetting = useSelector((state) => state.NewOrder.newOrder.deliveryMethod ? state.NewOrder.newOrder.deliveryMethod?.scheduleSetting?.isActive : false)
  const addressBookSource = useSelector((state) => state.Addressbook.openAddressBookInNewOrder
    ? state.Addressbook.sourceOfAddressBookInNewOrder
      ? state.Addressbook.sourceOfAddressBookInNewOrder.type == "pickup"
      : false
    : false)
    const auto_activeVehicleType = useSelector((state) => state.NewOrder.newOrder.pickup.driver.auto_driver.auto_activeVehicleType)
    const manual_activeVehicleType = useSelector((state) => state.NewOrder.newOrder.pickup.driver.manual_driver.manual_activeVehicleType)
    const driveroptions = useSelector((state) => state.NewOrder.newOrder.pickup.driver.options)
  const delayedQuerySP = React.useCallback(_.debounce((...pr) => HandleChangeSP(...pr), 500), []);

  const delayedQuery = React.useCallback(_.debounce((...pr) => HandleChange(...pr), 500), []);
  const auto_suggestListData = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_suggestListData)
  const pickup_manual_id = useSelector((state) => state.NewOrder.newOrder.pickup.driver.manual_driver.manual_id)
  const pickupLocationType = useSelector((state) => state.NewOrder.newOrder.deliveryMethod.pickupLocationType)
  const deliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod)
  // const pickupLocationType = useSelector((state) => state.NewOrder.newOrder.deliveryMethod?.dropoffLocationType)

  const [servicepoints, setServicepoints] = React.useState([]);
  const [servicepointsIsLoading, setServicepointsIsLoading] = React.useState(false);

  const HandleChangeSP = React.useCallback((value) => {

    (async () => {
      setServicepointsIsLoading(true)
      const Services = new ServicesApi();
      const ServicePoints = await Services.ServicePoints({
        deliveryMethodId: deliveryMethod?.id,
        locationType: "pickup",
        search: value
      })
      console.log("ServicePoints5 ", ServicePoints)
      setServicepoints(ServicePoints)
      setServicepointsIsLoading(false)

    })();

  }, [deliveryMethod]);


  const HandleChange = React.useCallback((value, localSearchIsActive, sessionToken) => {

    let centerr = getCenterMap(mapRef, center)
    String(value).length > 0 && dispatch(Set_SearchAutoCompleteLoading(true));

    console.log("localSearchIsActive ", localSearchIsActive)
    if (!localSearchIsActive) {
      String(value).length > 0 && dispatch(
        SearchAutoCompleteAction(dispatch, {
          query: value,
          latitude: centerr.lat,
          longitude: centerr.lng,
          sessionToken: sessionToken
        })
      );
    } else {
      String(value).length > 0 && dispatch(
        SearchAutoCompleteAction_local_address(dispatch, {
          query: value
        })
      );
    }


  }, [localSearchIsActive, sessionToken]);


  const handleSearchSPInput = React.useCallback((e, name) => {


    if (e?.target?.ignore) {
      return null
    }

    if (name === "address" || e?.target.id === "address") {






      if (e && e?.target.value != "") {
        e?.target?.value.length > 2 && delayedQuerySP(e?.target.value)

        if (e?.target?.value.length == 0 && address?.length > 0) {
          delayedQuerySP(e?.target.value)
        }
      }

      if (e?.target?.value.length == 0) {
        delayedQuerySP("")
      }

    }

    if (e) {
      dispatch(
        Set_Pickup_Inputs({
          name: name || e?.target.id,
          value: e?.target.value,
        })
      );
    }
  }, [sessionToken, localSearchIsActive]);


  const handlePickUpInputs = React.useCallback((e, name) => {

    if (name === "address" || e?.target.id === "address") {

      setSessionToken(sessionToken ? sessionToken : uuidv4())

      // dispatch(
      //   Set_Pickup_address({
      //     adresss_loc: { lng: "", lat: "" },
      //     placeId: "",
      //   })
      // );


      if (e && e?.target.value != "") {
        e?.target?.value.length > 2 && delayedQuery(e?.target.value, localSearchIsActive, sessionToken)
      }


      console.log("dwrwewdfwee",e)
    }
    if(e){
         dispatch(
      Set_Pickup_Inputs({
        name: name || e?.target.id,
        value: e?.target.value,
      })
    );
    }
 
  }, [sessionToken, localSearchIsActive]);

  const handleChangeLocalSearch = React.useCallback((value) => {

    setLocalSearchIsActive(value == t("Map") ? false : true)
    // setTimeout(() => {
    //   notThrottleHandleChange(String(address), sessionToken)
    // }, 200);

  }, [localSearchIsActive, sessionToken, address]);

  const notThrottleHandleChange = React.useCallback((value) => {

    let centerrr = getCenterMap(mapRef, center)
    String(value).length > 0 && dispatch(Set_SearchAutoCompleteLoading(true));



    if (!localSearchIsActive) {
      String(value).length > 0 && dispatch(
        SearchAutoCompleteAction(dispatch, {
          query: value,
          latitude: centerrr.lat,
          longitude: centerrr.lng,
          sessionToken: sessionToken
        })
      );
    } else {
      String(value).length > 0 && dispatch(
        SearchAutoCompleteAction_local_address(dispatch, {
          query: value
        })
      );
    }

  }, [localSearchIsActive, sessionToken]);


  React.useEffect(() => {
    notThrottleHandleChange(String(address), sessionToken)
  }, [localSearchIsActive])



  React.useEffect(() => {
    if (pickupLocationType != "address" && deliveryMethod?.id) {
      (async () => {
        setServicepointsIsLoading(true)
        const Services = new ServicesApi();
        const ServicePoints = await Services.ServicePoints({
          deliveryMethodId: deliveryMethod?.id,
          locationType: "pickup"
        })
        console.log("ServicePoints5 ", ServicePoints)
        setServicepoints(ServicePoints)
        setServicepointsIsLoading(false)

      })();
    }
  }, [pickupLocationType, deliveryMethod])


  const serachListData = React.useCallback(() => {

    if (pickupLocationType != "address") {
      if (servicepoints && !_.isEmpty(servicepoints)) {
        return servicepoints
      } else {
        return null
      }
    }


    if (_.isEmpty(address)) {
      if (_.isEmpty(customerId)) {
        return null //error customer
      } else {
        if (_.isEmpty(recentAddress)) {
          return null //error recentAddress
        } else {
          return recentAddress
        }
      }
    } else {
      if (_.isEmpty(suggestPickUpDropOffListData)) {
        return null //error suggestPickUpDropOffListData
      } else {
        return suggestPickUpDropOffListData
      }
    }


  }, [recentAddress, servicepoints, pickupLocationType, customerId, address, suggestPickUpDropOffListData]);


  const GetserachListItem = React.useCallback(() => {

    if (_.isEmpty(address)) {
      return RecentAddressItem
    } else {
      return AddressItem
    }


  }, [recentAddress, customerId, address, suggestPickUpDropOffListData , pickupLocationType]);


  const GetserachListItemOnclick = React.useCallback(() => {

    if (_.isEmpty(address)) {
      return handleRecentList
    } else {
      return handleList
    }


  }, [recentAddress, customerId, address, suggestPickUpDropOffListData]);


  const GetserachListItemOnclickSP = React.useCallback((item) => {

    dispatch(
      Set_latlng({ lng: item.coordinates.lng, lat: item.coordinates.lat })
    );

    dispatch(
      Set_Pickup_address({
        ...item,
        address: item.address,
        adresss_loc: { lng: item.coordinates.lng, lat: item.coordinates.lat },
        idx: item.id,
        name: item.name
      })
    );
    mapSetView({
      lng: item.coordinates.lng, lat: item.coordinates.lat
    });


  }, [recentAddress, customerId, address, suggestPickUpDropOffListData]);


  const GetSearchListError = React.useCallback(() => {


    if (pickupLocationType != "address") {
      if (_.isEmpty(address)) {
        if (!servicepoints || _.isEmpty(servicepoints)) {
          return {
            errorDescription: t("Add service points in admin center"),
            errorTitle: t("No service point available"),
            errorIcon: service_point,
            errorActionTitle: t("Add service point")
          }
        } else {
          return null
        }
      } else if (!_.isEmpty(address)) {
        if ((!servicepointsIsLoading && (servicepoints.length === 0 || _.isEmpty(servicepoints)))) {
          return {
            errorDescription: t("NoResultfromLocalDatabaseD"),
            errorIcon: null,
          }
        }
      }

    } else {
    //no recent address
    if (recentAddress.length == 0 && !_.isEmpty(customerId) && _.isEmpty(address)) {
      return {
        errorDescription: t("NoRecentAddressD"),
        errorTitle: t("NoRecentAddress"),
        errorIcon: HISTORY,
      }
    }

    //CustomerIsNotChoosed

    if (_.isEmpty(customerId) && _.isEmpty(address)) {
      return {
        errorDescription: t("CustomerIsNotChoosedD"),
        errorTitle: t("CustomerIsNotChoosed"),
        errorIcon: CUSTOMER_TYPE,
      }
    }



    if ((!suggestListPickUpDropOffLoading &&
      suggestPickUpDropOffListData.length === 0 && !_.isEmpty(address)) || (!_.isEmpty(address) && !suggestListPickUpDropOffLoading && !suggestPickUpDropOffListData)) {
      return {
        errorDescription: t("NoResultfromLocalDatabaseD"),
        errorTitle: t(localSearchIsActive ? "NoResultfromLocalDatabase" : "NoResultfromMapService"),
        errorIcon: null,
      }
    }

    }

  }, [pickupLocationType, servicepointsIsLoading , servicepoints, recentAddress, customerId, address, suggestPickUpDropOffListData, suggestListPickUpDropOffLoading, localSearchIsActive]);


  const handleRecentList = (item) => {

    dispatch(
      Set_latlng({ lng: item.coordinates[0], lat: item.coordinates[1] })
    );

    dispatch(
      Set_Pickup_address({
        ...item,
        address: item.address,
        adresss_loc: { lng: item.coordinates[0], lat: item.coordinates[1] },
        block: item.buildingBlock,
        floor: item.floor,
        unit: item.room
      })
    );
    mapSetView({
      lng: item.coordinates[0],
      lat: item.coordinates[1],
    });

    handleShowInfo()

  }

  const mapSetView = (e) => {
    setCenterMap(mapRef, e)
  };


  const handleList = (item) => {

    if (item.coordinates) {

      dispatch(
        Set_latlng({ lng: item.coordinates[0], lat: item.coordinates[1] })
      );


      dispatch(
        Set_Pickup_address({
          ...item,
          address: item.secondaryAddress
            ? item.address + " , " + item.secondaryAddress
            : item.address,
          adresss_loc: { lng: item.coordinates[0], lat: item.coordinates[1] },
        })
      );
      mapSetView({
        lng: item.coordinates[0],
        lat: item.coordinates[1],
      });

      setSessionToken(null)

      handleShowInfo()


    } else {

      let ss = sessionToken ? sessionToken : uuidv4()
      setSessionToken(ss)


      dispatch(
        PlaceIdDetailsAction(dispatch, { placeId: item.placeId, sessionToken: ss }, (res) => {

          setSessionToken(null)


          dispatch(
            Set_latlng({ lng: res.coordinates[0], lat: res.coordinates[1] })
          );

          dispatch(
            Set_Pickup_address({
              ...item,
              address:res.address,
              // address: item.secondaryAddress
              //   ? item.address + " , " + item.secondaryAddress
              //   : item.address,
              adresss_loc: { lng: res.coordinates[0], lat: res.coordinates[1] },
            })
          );
          dispatch(
            Set_latlng({
              lng: res.coordinates[0],
              lat: res.coordinates[1],
            })
          );
          handleShowInfo()

        })
      );


    }
  };


  const resetPickup = () => {
    dispatch(
      Set_Pickup_address({
        address: "",
        adresss_loc: { lng: "", lat: "" },
        placeId: "",
        idx:null,
        name:null
      })
    );
  };

  const handleShowInfo = React.useCallback(() => {

    const isOpen = activePickupDropOff.type === "pickup"
    
    const myEvent = new CustomEvent("closeSliders",{ detail:null});
    document.dispatchEvent(myEvent);


    if(!isOpen){
      handleCollapse({
        type: "pickup",
        id: "pickup",
      });
    }else{
         setTimeout(() => {
     handleCollapse({
      type: null,
      id: ""
     });
   }, 100);
    }

  }, [activePickupDropOff]);


  const emailValidate=(email)=> {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

 

  const vehicleRequiredCheck = React.useCallback(() => {

    if (orderTypeActive == "PickupDelivery") {
    let activeVehicleType = pickup_manual_id != "" && pickup_manual_id != null ? manual_activeVehicleType  : auto_activeVehicleType ;

    if (activeVehicleType) {
      if (activeVehicleType.options.length == 0) {
        console.log("vehicleRequiredCheck , 382 " )
        return true
      } else {
        let isNotExist = false;
        let arrFiltered = activeVehicleType.options.filter((item) => item.isRequired);
        arrFiltered.forEach(element => {
          if (!VehicleOptionisSaved( element.id)) {
            isNotExist = true;
          }
        });
        console.log("vehicleRequiredCheck , 392 " )
        return isNotExist == false
      }
    } else {
      console.log("vehicleRequiredCheck , 396 " )
      return true
    }

  }else {
    console.log("vehicleRequiredCheck , 396 " )
    return true
  }
  }, [auto , auto_activeVehicleType , manual_activeVehicleType , driveroptions , orderTypeActive]);


  const VehicleOptionisSaved=React.useCallback((id) => {
    console.log("VehicleOptionisSaved  ",id,driveroptions )

    let booll = false;
    booll = driveroptions.find((item) => {
      return item.id == id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }, [driveroptions]);


  const pickupRequiredCheck = React.useCallback(() => {
    if (activeVehicleType) {
      let name = false, email = false, phone = false;

      if (activeVehicleType.setting.isPickupAddressNameRequired) {
        if (senderFullName && String(senderFullName).trim().length > 0) {
          name = true
        } else {
          name = false
        }
      } else {
        name = true
      }

      if (activeVehicleType.setting.isPickupAddressPhoneRequired) {
        if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
          phone = true
        } else {
          phone = false
        }
      } else {
        phone = true
      }


      if (activeVehicleType.setting.isPickupAddressEmailRequired) {
        if (emailg && String(emailg).length > 0 && emailValidate(String(emailg))) {
          email = true
        } else {
          email = false
        }
      } else {
        email = true
      }



      return (name && phone && email);

    } else {
      return false
    }

  }, [activeVehicleType , emailg , senderPhoneNumber , senderFullName]);

  // const handleChangeLocalSearch = React.useCallback((value) => {


  // }, []);


  const openAddressbook = React.useCallback(() => {

    const myEvent = new CustomEvent("closeSliders",{ detail:null});
    document.dispatchEvent(myEvent);


  setTimeout(() => {
    if (customerId || BusinessId) {
      if (openAddressBook && addressBookSource) {
        dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));
      } else {
        dispatch(
          SetopenAddressBookInNewOrder(
            true,
            "pickup",
            null,
            "AddressbookPickup"
          )
        );
      }
    }
  }, 100);
  }, [customerId , BusinessId , openAddressBook , addressBookSource]);




  React.useEffect(() => {

    if (!auto_activeVehicleType && auto_suggestListData.length > 0) {
      dispatch(Set_Auto_ActiveVehicleTypeـPickupDeliveryType_Pickup(auto_suggestListData[0]))
    }

  }, [auto_activeVehicleType , auto_suggestListData])



  React.useEffect(() => {

try {
      document.addEventListener('closeSliders', () => {
       //
       handleCollapse({
        type: null,
        id: ""
      });
  
        //
      })
      return () => {
        document.removeEventListener("closeSliders",()=>{
          
        });
    };
} catch (error) {
  
}
  }, [])


 
  

  if (isEmpty(String(adresss_loc.lat))) {
    return <div className={styles.PickupOnlyNewOrderContainer}>

      <div className={styles.PickupOnlyNewOrderContainerFirstRow}>
        <IconProvider Icon={PICKUP} size='16' />
        <Typography text={t("Collection from")} weight='Body_Middle_Bold' />
        {address.length == 0 && <span className={styles.starRequired}>*</span>}
   {ActivescheduleSetting &&
        <Schedule orderType={orderTypeActive}
          scheduleDateBefore={scheduleDateBefore}
          scheduleDateAfter={scheduleDateAfter}
          id={id} 
                  type={"pickup"}
        />} 
      </div>

      <div className={styles.PickupOnlyNewOrderContainerSecondRow}>
        <SearchList DefaultListPreview={(isEmpty(address) && pickupLocationType != "address" && servicepoints && servicepoints.length > 0) && <div className={styles.DefaultListPreview}>
          <Typography weight='Body_Tiny_Medium' text={t("All Service points")} style={{ marginTop: "16px", marginBottom: "4px", width: "100%", width: "calc(100% - 24px)", marginInlineStart: "12px", marginInlineEnd: "12px", marginTop: "8px", color: "#484848" }} />
          <div className={styles.DefaultListItemsContainerPreview}>
            {servicepoints.map((item) => {
              return <ServicePoint_addressItem data={item} onclick={() => { GetserachListItemOnclickSP(item) }} />
            })}
          </div>

        </div>}  errorActionOnClick={()=>{
          window.location.replace("/admin/service-points/create")
        }} 
          inputIcon={<img src={pickupLocationType == "address" ? location_gray : service_point} />}
          onChange={pickupLocationType == "address" ? (e) => handlePickUpInputs(e, "address") : (e) => handleSearchSPInput(e, "address")}
          style={{ zIndex: "2" }} value={address} placeHolder={pickupLocationType == "address" ? t("Search and select address") : t("Search and select service point")}
          isloading={pickupLocationType == "address" ? suggestListPickUpDropOffLoading : servicepointsIsLoading}
          listItemOnclick={pickupLocationType == "address" ? GetserachListItemOnclick() : GetserachListItemOnclickSP}
          error={GetSearchListError()} errorDescription={GetSearchListError()?.errorDescription} errorTitle={GetSearchListError()?.errorTitle} errorIcon={GetSearchListError()?.errorIcon}
          ListItemChildren={pickupLocationType == "address" ? GetserachListItem() : ServicePoint_addressItem}
          list={serachListData()}
          inputInnerChildren={(isLocalAddressActive && pickupLocationType == "address") ? (<DropDown size='Small' placement='bottomEnd' text={localSearchIsActive ? t("Local") : t("Map")}
            data={[t("Map"), t("Local")]} onClick={handleChangeLocalSearch} />) : null}
        />
       {pickupLocationType == "address" && <Button icon={LOCATION} size='Medium' type='Secondary' style={{marginInlineEnd:"7px"}} onClick={handleShowInfo}  isActive={activePickupDropOff.type === "pickup"}/>}
       {pickupLocationType == "address" &&  <Button icon={ADDRESS_BOOK} size='Medium' type='Secondary' disabled={((customerId && String(customerId).length > 0) || (BusinessId && String(BusinessId).length > 0)) ? false : true} onClick={openAddressbook} isActive={addressBookSource} />}
      </div>
    </div>
  }

  return (
    <>

      <div className={styles.PickupOnlyNewOrderSelectedContainer}>

      <div className={styles.PickupOnlyNewOrderContainerFirstRow}>
        <IconProvider Icon={PICKUP} size='16' />
        <Typography text={t("Collection from")} weight='Body_Middle_Bold' />
        {ActivescheduleSetting &&
        <Schedule orderType={orderTypeActive}
          scheduleDateBefore={scheduleDateBefore}
          scheduleDateAfter={scheduleDateAfter}
          id={id} 
                  type={"pickup"}
        />} 
      </div>

        <div className={styles.PickupOnlyNewOrderSelectedContainerFrow} style={{ marginTop: (name && name.length > 0) && "4px" }}>
          {(name && name.length > 0) && <img src={service_point} />}

          <div style={{ display: "flex", flexDirection: "column", gap: "0px", flex: "1" }}>
            {(name && name.length > 0) && <Typography text={name} weight='Body_Middle_Regular' style={{
              width: "293px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px"
            }} />}
            <Typography text={address} weight={(name && name.length > 0) ? "Body_Tiny_Regular" : 'Body_Middle_Regular'} style={{
              width: "293px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px" , color : (name && name.length > 0) ? "rgba(128, 128, 128, 1)" : 'rgba(72, 72, 72, 1)'
          }} />
          </div>
          <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "8px 8px" }} onClick={resetPickup} />

        </div>


 
      <PickupInfoNewOrder handleShowInfo={handleShowInfo} pickupRequiredCheck={pickupRequiredCheck()} /> 
 
      </div>

    </>

  )
}

export default PickupNewOrder